import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { MerchantAccount, AccountStatus } from '../../shared';
import { emptyMfk } from '@uiowa/uiowa-mfk';

@Injectable({
    providedIn: 'root'
})
export class NewMerchantAccountResolver implements Resolve<MerchantAccount> {
    constructor() { }

    resolve(route: ActivatedRouteSnapshot) {
        var depositMfk = emptyMfk();
        var chargebackMfk = emptyMfk();
        return {
            status: AccountStatus.Draft,
            statusString: "Draft",
            generalInformation: {
                merchantProfileId: null,
                preferredMerchantName: null,
                customerServicePhoneNumber: null,
                productServiceSold: null
            },
            primaryContactInformation: {
                primaryContact: null,
                primaryContactFax: null
            },
            mfkInformation: {
                depositMfk: depositMfk,
                chargebackMfk: chargebackMfk
            },
            salesInformation: {
                estAnnualCreditCardSalesVol: null,
                estAvgTransactionAmt: null,
                inPersonCardAcceptanceChannel: null,
                mailTelephoneCardAcceptanceChannel: null,
                websiteCommerceCardAcceptanceChannel: null
            },
            processingInformation: {
                itSupportPerson: null,
                creditCardProcessingTechnologyCd: null,
                terminalTypeCd: null,
                paymentGatewayVendor: null,
                numberOfTerminals: null,
                systemName: null,
                systemVersion: null,
                posPaymentGatewayVendor: null,
                posHardware: null,
                businessJustification: null,
                pciComplianceDocument: null,
                processingStaffPeople: [],
                computerNames: []
            },
            additionalInfo: null
        } as MerchantAccount;
    }
}